import { render, staticRenderFns } from "./LettingsProperties.vue?vue&type=template&id=8f73bfa2&"
import script from "./LettingsProperties.vue?vue&type=script&lang=js&"
export * from "./LettingsProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports